const updateDisplayAttributes = (attributeStatus, points) => {
    return attributeStatus.map((status) => {
        if (points <= 500)
            status.displayValue =
                status.name !== "Ataque Crítico"
                    ? Math.ceil(points * status.baseValue)
                    : Math.floor(points * status.baseValue);
        else if (points > 500) {
            status.displayValue =
                status.name !== "Ataque Crítico"
                    ? Math.ceil(
                          500 * status.baseValue +
                              (points - 500) * status.highValue
                      )
                    : Math.floor(
                          500 * status.baseValue +
                              (points - 500) * status.highValue
                      );
        }
        return status;
    });
};

export default updateDisplayAttributes;
